import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteIncident = {
  name: "deleteIncident" as const,
  input: z.object({ incidentId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
